import { CustomerCareActionsWindowTitleSelector } from '../../../reducers/selectors/customer.selectors';
import { CONVERGENT_BILLER_DEMO_ACCESS } from '../../../security.attributes';
export var ACTIONS_STATE_NAME = 'index.customercare.customer.demoActions';
export function routing($stateProvider) {
  $stateProvider.state(ACTIONS_STATE_NAME, {
    url: '/demoActions',
    template: '<demo-actions></demo-actions>',
    data: {
      windowTitle: CustomerCareActionsWindowTitleSelector
    },
    securityAttributes: [CONVERGENT_BILLER_DEMO_ACCESS]
  });
}